<template>
    <Teleport to="body">
        <!-- <TransitionFade no-opacity> -->
        <div
            v-show="visable"
            class="transition-all duration-500 ease-in-out fixed inset-0 z-[4000] bg-white sm:bg-black sm:bg-opacity-70 overflow-scroll no-overscroll"
        >
            <!-- <TransitionScale> -->
            <div
                v-show="visable"
                :id="visable ? 'modal' : ''"
                ref="modal"
                :class="[modalClass]"
                :style="[modalStyle]"
                class="lg:w-fit mx-auto min-h-full md:py-[94px] xl:py-[120px]"
            >
                <slot />
            </div>
            <!-- </TransitionScale> -->
        </div>
        <!-- </TransitionFade> -->
    </Teleport>
</template>

<script>
import { onClickOutside } from '@vueuse/core'
import { TransitionFade, TransitionScale } from '@morev/vue-transitions'

export default {
    props: {
        visable: {
            type: Boolean,
            default: false,
        },
        modalClass: [String, Array, Object],
        modalStyle: {
            type: [Object, String],
            default: '',
        },
        headerClass: {
            type: String,
            default: 'bg-black stroke-white text-white px-6 ',
        },
        center: {
            type: Boolean,
            default: true,
        },
        canClose: {
            type: Boolean,
            default: true,
        },
        minimised: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['close', 'minimise'],

    mounted() {
        document.addEventListener('keydown', this.escClose)

        // onClickOutside(this.$refs.modal, (event) => {
        //     this.$emit('close')
        // })
    },

    unmounted() {
        document.removeEventListener('keydown', this.escClose)

        let body = document.body
        if (body.classList.contains('overflow-hidden')) {
            body.classList.remove('overflow-hidden')
            body.classList.remove('w-full')
        }
    },

    data() {
        return {
            showContent: false,
        }
    },

    methods: {
        escClose(event) {
            if (this.visable && event.keyCode === 27 && this.canClose && !this.minimised) {
                this.$emit('close')
            }
        },

        checkBodyClass() {
            let body = document.body

            if (this.visable && !this.minimised && !body.classList.contains('overflow-hidden')) {
                body.classList.add('overflow-hidden')
                // body.classList.add("fixed")
                body.classList.add('w-full')
            } else {
                body.classList.remove('overflow-hidden')
                // body.classList.remove("fixed")
                body.classList.remove('w-full')
            }
        },
    },

    watch: {
        visable() {
            this.checkBodyClass()
        },

        minimised() {
            this.checkBodyClass()
        },
    },

    components: { TransitionFade, TransitionScale },
}
</script>
